import type { RouteRecordRaw } from 'vue-router'
import { getComponent } from '../utils'
import Layout from '@/layouts/main-layout.vue'

export const model_routes: RouteRecordRaw[] = [
  {
    path: '/model/list',
    name: 'model-list',
    component: () => getComponent(`pages/model/model-list.vue`),
    meta: {
      title: () => 'Models',
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/model/:id(\\d+)+',
    name: 'model-details',
    component: () => getComponent(`pages/model/model-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Model #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
]
